import React from "react";
import Vegliste from "../../interfaces/Vegliste.interface";
import {
  VeglisteData,
  VeglisteTableRowValues,
  VeglisteHeaderCells
} from "../../interfaces/Vegliste.interface";

import SimpleTable from "./EnhancedTable";

interface TableProps {
  data: Vegliste;
  className?: string;
}

const createHeaderCells = (
  headerLabels: Array<string>
): Array<VeglisteHeaderCells> => {
  return [
    { id: "veg", label: headerLabels[0] },
    { id: "vegstrekning", label: headerLabels[1] },
    { id: "veglengde", label: headerLabels[2] },
    { id: "totalvekt", label: headerLabels[3] },
    { id: "tillattVogntoglengde", label: headerLabels[4] },
    { id: "linkmodulevogntog", label: headerLabels[5] },
    { id: "vinterMaks", label: headerLabels[6] },
    { id: "merknad", label: headerLabels[7] }
  ];
};

function createVeglisteData(
  veg: string,
  vegstrekning: string,
  veglengde: string,
  totalvekt: string,
  tillattVogntoglengde: string,
  linkmodulevogntog: string,
  vinterMaks: string,
  merknad: string
): VeglisteData {
  return {
    veg,
    vegstrekning,
    veglengde,
    totalvekt,
    tillattVogntoglengde,
    linkmodulevogntog,
    vinterMaks,
    merknad
  };
}

const createRows = (
  veglisteTableRowValues: Array<VeglisteTableRowValues>
): Array<VeglisteData> => {
  const rows = new Array<VeglisteData>();
  veglisteTableRowValues.forEach(veglisteTableRow => {
    rows.push(
      createVeglisteData(
        veglisteTableRow.verdier[0],
        veglisteTableRow.verdier[1],
        veglisteTableRow.verdier[2],
        veglisteTableRow.verdier[3],
        veglisteTableRow.verdier[4],
        veglisteTableRow.verdier[5],
        veglisteTableRow.verdier[6],
        veglisteTableRow.verdier[7]
      )
    );
  });
  return rows;
};

const Table: React.FunctionComponent<TableProps> = props => {
  return (
    <div>
      {/* Create a table for display from each vegliste-table */}
      {props.data.tabeller.map((veglisteTabell, index) => {
        return (
          <div key={"table" + index}>
            <SimpleTable
              tableTitle={veglisteTabell.navn}
              headerCells={createHeaderCells(veglisteTabell.rader[0].verdier)}
              rows={createRows(veglisteTabell.rader.slice(1))}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Table;
